import { useCallback, useMemo, useState } from 'react';
import { initVisitor } from '@laigu/utils';

import { getQueueApi, inviteQueueApi } from './api';
import { getQueue, getQueueInline, addQueue, removeQueue, queueOffline, queueOnline } from '../../../reducers/visitor';
import { useDispatch } from '../../../react-redux';

window.hasRequestQueue = window.hasRequestQueue || false;
window.requestQueueLoading = window.requestQueueLoading || false;

const useQueue = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleInviteQueue = useCallback(({ trackId, entId }) => {
    return inviteQueueApi({
      trackId: trackId,
      entId: entId
    });
  }, []);

  const handleGetQueue = useCallback(({ forceRequest } = { forceRequest: false }) => {
    // window.requestQueueLoading = true;
    // setLoading(true);
    // if (forceRequest || (!window.hasRequestQueue && !loading)) {
    //   return getQueueApi()
    //     .then(res => {
    //       if (res?.data?.queue) {
    //         const newVisits = res.data.queue;
    //         window.hasRequestQueue = true;
    //         dispatch(getQueue(newVisits.map(val => initVisitor(val))));
    //         dispatch(getQueueInline(res.data.total_length));
    //       }
    //     })
    //     .finally(() => {
    //       window.requestQueueLoading = false;
    //       setLoading(false);
    //     });
    // }
  }, []);

  const extraAction = useMemo(() => {
    const actionKeyName = ['addQueue', 'removeQueue', 'queueOffline', 'queueOnline'];
    return [addQueue, removeQueue, queueOffline, queueOnline].reduce((prev, now, index) => {
      return {
        ...prev,
        [actionKeyName[index]]: param => dispatch(now(param))
      };
    }, {});
  }, [dispatch]);

  return {
    handleGetQueue,
    handleInviteQueue,
    loading,
    ...extraAction
  };
};

export default useQueue;
